import { type RouteConfig } from 'vue-router'

export const privateSectionsRouter: RouteConfig[] = [
  {
    path: '/privateSections',
    component: async () => import('./PrivateSections.vue'),
  },
]
